import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Page404 from 'pages/Error404'
import { getSingleProjectByUserAdmin } from 'api/projectApi'
import LoadingPage from 'pages/LoadingPage'

const ProtectedRouteByMongoAdmin = ({ children }) => {
  const { idProject } = useParams()
  const [hasAccess, setHasAccess] = useState(null) // null = cargando, true = ok, false = sin permisos

  useEffect(() => {
    const checkAccess = async () => {
      try {
        await getSingleProjectByUserAdmin(idProject)
        setHasAccess(true)
      } catch {
        setHasAccess(false)
      }
    }

    checkAccess()
  }, [idProject])

  if (hasAccess === null) return <LoadingPage />
  if (!hasAccess) return <Page404 />

  return <>{children}</>
}

export default ProtectedRouteByMongoAdmin
